export default "__VITE_ASSET__ChV6PJhY__"